<template>
  <div
    class="my-wrapper"
    :class="{ 'my-wrapper--dragging': isDragging }"
  >
    <table
      v-if="list.length"
      class="table table-striped drag-drop-table"
    >
      <thead class="drag-drop-table__head">
        <tr>
          <th scope="col">
            Номер
          </th>
          <th scope="col">
            Название
          </th>
        </tr>
      </thead>
      <draggable
        :key="list.length"
        v-model="list"
        tag="tbody"
        handle=".drag-handle"
        :animation="220"
        :force-fallback="true"
        :fallback-on-body="false"
        fallback-tolerance="3"
        fallback-class="drag-drop-table__fallback"
        ghost-class="drag-drop-table__ghost"
        chosen-class="drag-drop-table__chosen"
        drag-class="drag-drop-table__drag"
        @start="onDragStart"
        @end="onDragEnd"
      >
        <tr
          v-for="(item, index) in list"
          :key="item.id"
          class="drag-drop-table__row"
        >
          <td scope="row">
            <div class="drag-drop-table__num-cell">
              <span
                class="drag-handle"
                title="Перетащить"
              >
                <feather-icon
                  icon="MenuIcon"
                  size="18"
                />
              </span>
              <span class="drag-drop-table__index">{{ index + 1 }}</span>
            </div>
          </td>
          <td v-if="item.type">
            {{ item.type }}
          </td>
          <td v-else-if="item.name && item.surname">
            {{ item.name + ' ' + item.surname }}
          </td>
          <td v-else-if="item.name">
            {{ item.name }}
          </td>
          <td v-else-if="item.question">
            {{ item.question }}
          </td>
        </tr>
      </draggable>
    </table>
    <div
      v-else
      class="empty"
    >
      Нет элементов для выбора
    </div>
    <b-button
      variant="primary"
      class="mr-1 drag-drop-table__submit"
      @click="select"
    >
      Принять
    </b-button>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    draggable,
    BButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      isDragging: false,
      tableWidth: null,
    }
  },
  watch: {
    items(newVal) {
      if (newVal) {
        this.sortedList([...this.items])
      }
    },
  },
  mounted() {
    this.sortedList([...this.items])
  },

  beforeDestroy() {
    this.list = []
    this.clearDragLock()
  },
  methods: {
    onDragStart(evt) {
      this.isDragging = true
      document.body.classList.add('drag-drop-table--no-select')
      const table = this.$el.querySelector('.drag-drop-table')
      if (table) {
        this.tableWidth = table.offsetWidth
      }
      this.$nextTick(() => this.syncFallbackWidth(evt.item))
    },
    onDragEnd() {
      this.isDragging = false
      this.clearDragLock()
    },
    clearDragLock() {
      document.body.classList.remove('drag-drop-table--no-select')
    },
    syncFallbackWidth(rowEl) {
      const fallback = this.$el.querySelector('.drag-drop-table__fallback')
        || this.$el.querySelector('.sortable-fallback')
      const width = this.tableWidth || rowEl?.offsetWidth
      if (!fallback || !width) return

      fallback.style.width = `${width}px`
      fallback.style.maxWidth = `${width}px`
      fallback.style.boxSizing = 'border-box'
    },
    select() {
      const orderArray = this.list.map(e => e.id)
      this.$emit('select', orderArray)
    },
    sortedList(value) {
      if (value.length) {
        const res = value.sort((a, b) => a.order - b.order)
        this.list = res
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #7367f0;

.my-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.empty {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  width: 100%;
}

.drag-drop-table {
  margin-bottom: 0;
  border-radius: 0.428rem;
  overflow: hidden;
  width: 100%;
  table-layout: fixed;
}

.my-wrapper--dragging {
  user-select: none;
}

.drag-drop-table__num-cell {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.drag-handle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem;
  color: #b9b9c3;
  border-radius: 0.25rem;
  cursor: grab;
  touch-action: none;
  user-select: none;
  transition: color 0.15s ease, background-color 0.15s ease;

  &:hover {
    color: $primary;
    background-color: rgba($primary, 0.1);
  }

  &:active {
    cursor: grabbing;
  }
}

.my-wrapper--dragging .drag-drop-table__row:not(.drag-drop-table__chosen) {
  transition: opacity 0.2s ease;
}

.drag-drop-table__submit {
  align-self: stretch;
}
</style>

<style lang="scss">
$primary: #7367f0;

/* Светлая тема: светлый фон, тёмный текст */
:not(.dark-layout) .my-wrapper .drag-drop-table__head th {
  background-color: #f3f2f7 !important;
  color: #5e5873 !important;
  border-color: #ebe9f1 !important;
}

/* Тёмная тема: тёмный фон, светлый текст */
.dark-layout .my-wrapper .drag-drop-table__head th {
  background-color: #343d55 !important;
  color: #d0d2d6 !important;
  border-color: #3b4253 !important;
}

/* Строки */
:not(.dark-layout) .my-wrapper .drag-drop-table__row {
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background-color: rgba($primary, 0.06) !important;
  }
}

.dark-layout .my-wrapper .drag-drop-table__row {
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background-color: rgba(157, 147, 246, 0.1) !important;
  }

  .drag-handle {
    color: #676d7d;

    &:hover {
      color: #b4b7bd;
      background-color: rgba(157, 147, 246, 0.15);
    }
  }
}

/* Блокировка выделения текста на странице во время drag */
body.drag-drop-table--no-select,
body.drag-drop-table--no-select * {
  user-select: none !important;
  -webkit-user-select: none !important;
}

.my-wrapper--dragging .drag-drop-table__row,
.my-wrapper--dragging .drag-drop-table__head {
  user-select: none;
}

/* Перетаскивание */
.my-wrapper .drag-drop-table__chosen {
  background-color: rgba($primary, 0.1) !important;
  box-shadow: 0 4px 14px rgba($primary, 0.18) !important;
  z-index: 2;
  position: relative;

  td {
    border-top-color: rgba($primary, 0.35) !important;
    border-bottom-color: rgba($primary, 0.35) !important;
  }
}

.my-wrapper .drag-drop-table__ghost {
  opacity: 0.45 !important;
  background-color: rgba($primary, 0.06) !important;

  td {
    border-top: 2px dashed rgba($primary, 0.45) !important;
    border-bottom: 2px dashed rgba($primary, 0.45) !important;
  }
}

.my-wrapper .drag-drop-table__drag {
  opacity: 1 !important;
}

/* Плавающая копия строки — ширина как у таблицы, не на весь экран */
.my-wrapper .drag-drop-table__fallback {
  display: table;
  table-layout: fixed;
  box-sizing: border-box;
  background-color: #fff !important;
  box-shadow: 0 8px 24px rgba($primary, 0.25) !important;
  border-radius: 0.428rem;
  cursor: grabbing !important;
  opacity: 1 !important;
  z-index: 1055;

  td {
    background-color: inherit !important;
    vertical-align: middle;
  }
}

.dark-layout .my-wrapper .drag-drop-table__fallback {
  background-color: #283046 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;

  td {
    color: #d0d2d6 !important;
    border-color: #3b4253 !important;
  }
}

.dark-layout .my-wrapper .drag-drop-table__chosen {
  background-color: rgba(157, 147, 246, 0.14) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35) !important;
}

.dark-layout .my-wrapper .drag-drop-table__ghost {
  background-color: rgba(157, 147, 246, 0.08) !important;
}
</style>
